// Autogenerated file
export const extendedPropertyKindsEnum = {
    Bid: "Bid",
    BidPoint: "BidPoint",
    BidCargo: "BidCargo",
};
export const extendedPropertyKinds = [
    { label: "Заявка", value: "Bid" },
    { label: "Точка заявки", value: "BidPoint" },
    { label: "Груз заявки", value: "BidCargo" },
];
